module.exports = __webpack_public_path__ + "static/media/6-5.bad2e124.mp3";